export default {
  liveclasses: [],
  currentLiveClass: {}
}
